import React from 'react';
import { Stack } from '@atlaskit/primitives';
import { AgentConversationStarters } from '@atlaskit/rovo-agent-components';
export var ConversationStarters = function ConversationStarters(_ref) {
  var isAgentDefault = _ref.isAgentDefault,
    onConversationStarterClick = _ref.onConversationStarterClick,
    userDefinedConversationStarters = _ref.userDefinedConversationStarters;
  var handleConversationStarterClick = function handleConversationStarterClick(conversationStarter) {
    onConversationStarterClick(conversationStarter);
  };
  return /*#__PURE__*/React.createElement(Stack, {
    space: "space.050",
    alignInline: "start"
  }, /*#__PURE__*/React.createElement(AgentConversationStarters, {
    isAgentDefault: isAgentDefault,
    onConversationStarterClick: handleConversationStarterClick,
    userDefinedConversationStarters: userDefinedConversationStarters
  }));
};